module.exports = __webpack_public_path__ + "static/pp1-20ad98320443dc7264629730011ea0dd.png";